module.exports={
  "name": "js-conflux-sdk",
  "description": "JavaScript Conflux Software Development Kit",
  "version": "1.6.0",
  "license": "LGPL-3.0",
  "author": "Haizhou@conflux-chain.org",
  "repository": "https://github.com/Conflux-Chain/js-conflux-sdk.git",
  "keywords": [
    "conflux",
    "sdk"
  ],
  "main": "src/index.js",
  "types": "./types/index.d.ts",
  "browser": "dist/js-conflux-sdk.umd.min.js",
  "browserify-browser": {
    "secp256k1": "secp256k1/elliptic",
    "./src/util/jsbi": "jsbi"
  },
  "files": [
    "dist",
    "mock",
    "src",
    "types"
  ],
  "browserslit": "cover 99.5%",
  "dependencies": {
    "@babel/runtime": "^7.8.4",
    "big.js": "^5.2.2",
    "@conflux-dev/conflux-address-js": "^1.0.0",
    "keccak": "^2.0.0",
    "lodash": "^4.17.19",
    "scrypt-js": "^3.0.1",
    "secp256k1": "^3.7.1",
    "superagent": "^5.1.0",
    "websocket": "^1.0.31"
  },
  "devDependencies": {
    "@babel/core": "^7.8.4",
    "@babel/plugin-transform-runtime": "^7.8.3",
    "@babel/preset-env": "^7.8.4",
    "@geekberry/jsdoc-to-md": "0.0.8",
    "@types/node": "^14.0.23",
    "babel-plugin-lodash": "^3.3.4",
    "babelify": "^10.0.0",
    "browserify": "^16.5.1",
    "concurrently": "^5.1.0",
    "eslint": "^7.12.0",
    "eslint-config-airbnb-base": "^14.0.0",
    "eslint-plugin-import": "^2.18.2",
    "exorcist": "^1.0.1",
    "fs-extra": "^8.1.0",
    "jest": "26.6.0",
    "jsbi": "^3.1.4",
    "minify-stream": "^2.0.1",
    "mold-source-map": "^0.4.0",
    "solc": "^0.6.10"
  },
  "resolutions": {
    "tinyify/acorn-node/acorn": "7.1.1",
    "eslint/espree/acorn": "7.1.1",
    "tinyify/unassertify/unassert/acorn": "7.1.1",
    "**/minimist": "^1.2.3",
    "**/kind-of": "^6.0.3",
    "**/elliptic": "^6.5.3",
    "**/lodash": "^4.17.20",
    "**/babel-jest": "^26.6.0",
    "jest/jest-cli/jest-config/jest-environment-jsdom/jsdom/acorn-globals/acorn": "6.4.1"
  },
  "scripts": {
    "eslint": "eslint ./src ./test ./mock",
    "build": "node scripts/build-frontend.js",
    "document": "node scripts/document.js",
    "prepublishOnly": "npm run build",
    "test": "jest --coverage",
    "react": "npm run build & cd react & yarn build & yarn start"
  }
}
